import { render } from "./EditAppointmentDoctor.vue?vue&type=template&id=0ebc4206&scoped=true"
import script from "./EditAppointmentDoctor.vue?vue&type=script&lang=js"
export * from "./EditAppointmentDoctor.vue?vue&type=script&lang=js"

import "./EditAppointmentDoctor.vue?vue&type=style&index=0&id=0ebc4206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebc4206"]])

export default __exports__